import React from 'react';
import Sidebar from '../components/Sidebar';
import { useTheme } from '../contexts/ThemeContext';

/**
 * 主要頁面佈局
 * 包含 Sidebar + 主內容區
 *
 * @param {string} activePage - 當前頁面標識，用於 Sidebar 高亮
 * @param {React.ReactNode} children - 頁面內容
 * @param {string} className - 額外的 className
 * @param {string} title - 頁面標題
 * @param {string} subtitle - 頁面副標題
 * @param {React.ReactNode} headerActions - 標題右側的操作按鈕
 */
function MainLayout({ activePage, children, className = '', title, subtitle, headerActions }) {
  const { theme } = useTheme();

  return (
    <div
      className="min-h-screen"
      style={{ background: theme.bgPrimary, color: theme.textPrimary }}
    >
      <div className="flex h-screen">
        <Sidebar activePage={activePage} />
        <main className={`flex-1 overflow-y-auto ${className}`}>
          {/* Page Header with Title/Subtitle */}
          {title && (
            <div className="px-10 py-6 border-b border-gray-200 bg-white sticky top-0 z-10">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="m-0 text-2xl font-bold text-gray-900">{title}</h1>
                  {subtitle && (
                    <p className="m-0 mt-1 text-sm text-gray-500">{subtitle}</p>
                  )}
                </div>
                {headerActions && (
                  <div className="flex items-center gap-3">
                    {headerActions}
                  </div>
                )}
              </div>
            </div>
          )}
          {children}
        </main>
      </div>
    </div>
  );
}

export default MainLayout;
